import React from 'react'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import RoomImagesTable from './Components/RoomImagesTable';

const RoomImagesList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Add Room Images</HeadingOne>
                    <AddItemBtn url="add-room-image" title="Add Room Images" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <RoomImagesTable />
            </div>
        </PageBody>
    );
};

export default RoomImagesList;
